import React from "react";
import { useUiPack } from "@/hooks/useUiPack";
import AppShell from "@/components/layout/AppShell";
import SimpleAppShell from "@/components/simple/SimpleAppShell";

/** Picks Classic or Simple shell from company ui_pack. */
export default function UiPackShell() {
  const { isSimple } = useUiPack();
  return isSimple ? <SimpleAppShell /> : <AppShell />;
}
